import React from 'react';
import styled from 'styled-components';
import HeaderEs from '../common/header/HeaderEs';
import { useHistory } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { reqEsDetailInfoAction } from '../../modules/od/orderModule';
import { useSelector, useDispatch } from 'react-redux';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../common/popup/NormalPopup';
import { delEsItemAction, updateEsItemStatusAction } from '../../modules/es/esItemModule';
import moment from "moment";
import {
    EsReqMustGuide, EsReqDvryInfo, EsReqDvryGuide,
    EsReqRefund,EsComItemList, EsComSummary
    }
    from './'

import {isMobileOnly} from 'react-device-detect';

// Modal Stryle
export const EsReqDonePopupModalStyles = {
    content: {
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        marginRight: 'auto',
        postion: 'fixed',

        zIndex: '999',
        overlay: 'auto',
        WebkitOverflowScrolling: 'touch',
        width: "100%",
        height: "100%",
        borderRadius: '0px',
        backgroundColor: '#fff',
        borderWidth: '0px',
        padding: 0
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: '1000'
    }
};

const EsReqDoneInfoPopupBlock = styled.div`
  ${isMobileOnly&&`margin: 0 4vw;`};
  .mobile-header {margin:40px; text-align: center;}
`;

const EsReqDoneWrapBlock = styled.div`
    padding: 120px 0 179px;  
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
    
    //.flex-jcc {display: flex; justify-content: center;}
`;

const EsReqDoneMobileWrapBlock = styled.div`
  
    padding-bottom: 170px;
    // .splitter {border-bottom: 2px solid #ececec; padding-bottom:10px;}
    //.product-table {
    //  margin: 10px 0;
    //  border-top: 2px solid #111;  
    //}    
`;

const EsReqDonePopup = ({ esItem, onCloseClick }) => {

    const history = useHistory();
    const dispatch = useDispatch();
    const [msg, setMsg] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const { es_rqst_id, pckg_nm, rqst_date_format, brnd_han, rqst_price,
        es_dscnt_total_price, es_prdct_total_price, es_final_price,
        expr_date, es_dlvry_total_price, es_detail_dlvry_pay_type, total_qty,
        es_pay_price, dsrd_date_format,es_add_dscnt_price_total, rqst_status, cancel_date_format, dday
    } = esItem[0];

    let date = new Date();
    let date1 = new Date(expr_date);
    date1.setHours(0,0,0,0);
    date.setHours(0,0,0,0);

    // let diffDay = (date.getTime()-date1.getTime())/(1000*60*60*24)
    let diffDay = dday;
    // console.log("diffDay = " + diffDay);

    var { esItemDetailInfo, esStatusRes } = useSelector(
        ({ esOrderReducer, esItemsReducer }) => ({
            esItemDetailInfo: esOrderReducer.esItemDetailInfo,
            esStatusRes: esItemsReducer.esStatusRes,
        })
    );

    useEffect(() => {
        dispatch(reqEsDetailInfoAction(es_rqst_id))
    }, [])

    useEffect(() => {
        //console.log('esStatusRes = ' + JSON.stringify(esStatusRes));
        if(esStatusRes !== null && esStatusRes*1 ===200) {
            //console.log('esStatusRes222 = ' + JSON.stringify(esStatusRes));
            setOpenModal(false);
            history.replace('/es');
            //onCloseClick();
        }
    }, [esStatusRes])

    const handleSubmit = () => {
        if(diffDay < 0){

        }
        else {
            history.push("/order?reqid=" + es_rqst_id);
        }
    }

    // Delete 처리
    const handleClickDelBtn = () => {
        setMsg("견적을 취소하면 주문할 수 없어요.\n그래도 취소하시겠어요?");
        setOpenModal(true);
    }

    const handleModalClose = () => {
        setOpenModal(false);
    }

    // 확인
    const handleModalBtn1Click = () => {
        dispatch(updateEsItemStatusAction(es_rqst_id,"050111")); //050110 -> 견적취소
        /* dispatch(delEsItemAction(es_rqst_id));
        setOpenModal(false);
        onCloseClick(); */
    }

    // 닫기
    const handleModalBtn2Click = () => {
        setOpenModal(false);
    }

    const getSendDate = () => {
        if(esItemDetailInfo !== null && esItemDetailInfo !== undefined){
            if(esItemDetailInfo.masterinfo !== null && esItemDetailInfo.masterinfo !== undefined){

                if(esItemDetailInfo.masterinfo.es_send_date !== null  && esItemDetailInfo.masterinfo.es_send_date !== undefined){

                    return moment(esItemDetailInfo.masterinfo.es_send_date).format('YYYY년 MM월 DD일');
                }
            }
        }

        return "";
    }

    const getExprDate = () => {
        if(esItemDetailInfo !== null && esItemDetailInfo !== undefined){
            if(esItemDetailInfo.masterinfo !== null && esItemDetailInfo.masterinfo !== undefined){

                if(esItemDetailInfo.masterinfo.expr_date !== null  && esItemDetailInfo.masterinfo.expr_date !== undefined){

                    return moment(esItemDetailInfo.masterinfo.expr_date).format('YYYY년 MM월 DD일');
                }
            }
        }

        return "";
    }


    const getStatusMsg = () => {
        if(rqst_status==='050111') {
            return (
                <div className="es_apply_info-box margin_t-30">
                <p className="eai-title margin_b-10">
                정상 견적서가 취소처리 되었어요😢
                </p>
                새로운 견적을 알아볼까요?<br/>
                <p className="margin_t-20 margin_b-5">
                    견적일 :
                    <span className="font-mont"> {rqst_date_format}</span>
                </p>
                <p className="margin_b-30">
                    취소일 :
                    <span className="font-mont"> {cancel_date_format}</span>
                </p>
            </div>
            )
        }
        if(diffDay < 0) {
            return (
            <div className="es_apply_info-box margin_t-30">
                <p className="eai-title margin_b-10">
                아쉽지만 견적 주문 기한이 만료되었어요😭
                </p>
                새로운 견적을 알아볼까요?<br/>
                <p className="margin_t-20 margin_b-5">
                    견적일 :
                    <span className="font-mont"> {getSendDate()}</span><br/>
                </p>
                <p className="margin_b-10">
                    만료일 :
                    <span className="font-mont"> {getExprDate()}</span>
                </p>
            </div>
        )

        }
        else {
            return (
                <div className="es_apply_info-box margin_t-30">
                <p className="eai-title margin_b-10">
                견적서가 도착했어요🙂
                </p>
                다른 견적서와 비교해보는건 어떨까요?<br/>
                <p className="margin_t-20 margin_b-5">
                    견적일 :
                    <span className="font-mont"> {getSendDate()}</span><br/>
                </p>
                <p className="margin_b-10">
                    만료일 :
                    <span className="font-mont"> {getExprDate()}</span>
                </p>
            </div>
            )
        }
    }

    return (
        <EsReqDoneInfoPopupBlock>
            {isMobileOnly?
              <div className="flex vc fe">
                  <div className="mobile-header title-xl font-bold margin_b-40 margin_t-40 flex-1 text_center">{brnd_han}</div>
                  < i className="fas fa-times fa-2x" onClick={onCloseClick}/>
              </div>
            :
            <HeaderEs
                rqst_id={es_rqst_id} name={brnd_han}
                onCloseClick={onCloseClick}
            />
            }

            {isMobileOnly?
              <EsReqDoneMobileWrapBlock>
                  <div className="title-lg margin_b-30">
                      {pckg_nm}
                  </div>
                  <div className="flex vc jsb">
                      <div>{es_rqst_id}</div>
                      <div>유효기간: {expr_date}</div>
                  </div>

                  <div className="margin_b-80">
                      <EsComItemList items={esItem} />
                  </div>
                  <EsComSummary item={esItem[0]} type="responsive"/>
                  <EsReqMustGuide
                    detailInfo={esItemDetailInfo} />

                  <EsReqDvryInfo detailInfo={esItemDetailInfo}
                                 dsrd_date_format={dsrd_date_format} rqst_status={rqst_status}/>


                  {/*<EsReqDvryGuide detailInfo={esItemDetailInfo} />*/}

                  <EsReqRefund detailInfo={esItemDetailInfo} />
                  {getStatusMsg()}
              </EsReqDoneMobileWrapBlock>
              :
              <EsReqDoneWrapBlock>
                  <div className="es_title-box margin_b-80">
                      <div className="es_title-box margin_b-40">
                          <h3 className="es_title margin_b-10"> {pckg_nm}</h3>
                          <span className="es_title-sub">유효기간 <span className="font-mont">{expr_date}</span></span>
                      </div>
                  </div>

                  <EsComSummary item={esItem[0]} type="equation" />

                  <div className="margin_b-80">
                      <div className="filter-top myes_top clearfix">
                          <span className="f-left">견적 요청일 <span className="font-mont">{rqst_date_format}</span></span>

                      </div>

                      <div className="product-table default-table">
                          <table>
                              <colgroup>
                                  <col width="550px;" />
                                  <col width="156px;" />
                                  <col width="156px;" />
                                  <col width="156px;" />
                                  <col width="156px;" />
                              </colgroup>

                              <thead>
                              <tr>
                                  <th>상품 정보</th>
                                  <th>상품 금액</th>
                                  <th>할인 금액</th>
                                  <th>배송비</th>
                                  <th>견적 금액</th>
                              </tr>
                              </thead>

                              <tbody>
                                <EsComItemList items={esItem}/>
                              </tbody>
                              <EsComSummary item={esItem[0]} type="tableTr"/>
                          </table>
                      </div>
                  </div>

                  <EsReqMustGuide
                    detailInfo={esItemDetailInfo} />

                  <EsReqDvryInfo detailInfo={esItemDetailInfo}
                                 dsrd_date_format={dsrd_date_format} rqst_status={rqst_status}/>


                  {/*<EsReqDvryGuide detailInfo={esItemDetailInfo} />*/}

                  <EsReqRefund detailInfo={esItemDetailInfo} />
                    {getStatusMsg()}
              </EsReqDoneWrapBlock>
            }

            {rqst_status==='050111' || diffDay < 0 ?
            ''
            :
            <div className="full_popup_btn-wrap">
                    <button type="button" className="mh-btn gray-btn" onClick={handleClickDelBtn}>견적 취소</button>
                    {diffDay < 0 ?
                        <button className="mh-btn lgray-btn margin_l-30" style={{pointerEvents : 'none'}}>주문기한 만료</button>
                    :
                        <button className="mh-btn yellow-btn margin_l-30" onClick={handleSubmit}>주문하기</button>
                    }

                </div>
            }
            {/* <div className="full_popup_btn-wrap">
                <button type="button" className="mh-btn gray-btn" onClick={handleClickDelBtn}>견적 취소</button>
                {diffDay > 0 ?
                    <button className="mh-btn lgray-btn margin_l-30" style={{pointerEvents : 'none'}}>주문기한 만료</button>
                :
                    <button className="mh-btn yellow-btn margin_l-30" onClick={handleSubmit}>주문하기</button>
                }

            </div> */}
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalClose}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {
                    <NormalPopup
                        text=""
                        text2={msg}
                        btn1="예" btn2="아니오"
                        onClick1={handleModalBtn1Click}
                        onClick2={handleModalBtn2Click} />
                }

            </Modal>
        </EsReqDoneInfoPopupBlock>
    );
};

export default EsReqDonePopup;
